/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { OutExternalDealFilterDTO } from "./OutExternalDealFilterDTO";
import {
  OutExternalDealFilterDTOFromJSON,
  OutExternalDealFilterDTOFromJSONTyped,
  OutExternalDealFilterDTOToJSON
} from "./OutExternalDealFilterDTO";

/**
 *
 * @export
 * @interface ExternalDealFilterListResponseDTO
 */
export interface ExternalDealFilterListResponseDTO {
  /**
   *
   * @type {number}
   * @memberof ExternalDealFilterListResponseDTO
   */
  total: number;
  /**
   *
   * @type {Array<OutExternalDealFilterDTO>}
   * @memberof ExternalDealFilterListResponseDTO
   */
  externalDealFilters: Array<OutExternalDealFilterDTO>;
}

/**
 * Check if a given object implements the ExternalDealFilterListResponseDTO interface.
 */
export function instanceOfExternalDealFilterListResponseDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "total" in value;
  isInstance = isInstance && "externalDealFilters" in value;

  return isInstance;
}

export function ExternalDealFilterListResponseDTOFromJSON(json: any): ExternalDealFilterListResponseDTO {
  return ExternalDealFilterListResponseDTOFromJSONTyped(json, false);
}

export function ExternalDealFilterListResponseDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExternalDealFilterListResponseDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    total: json["total"],
    externalDealFilters: (json["externalDealFilters"] as Array<any>).map(OutExternalDealFilterDTOFromJSON)
  };
}

export function ExternalDealFilterListResponseDTOToJSON(value?: ExternalDealFilterListResponseDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    total: value.total,
    externalDealFilters: (value.externalDealFilters as Array<any>).map(OutExternalDealFilterDTOToJSON)
  };
}
